<script lang="ts" setup>
defineProps<{
  currentValue: number;
  totalValue: number;
  failedValues: number;
  actionText: string;
}>();
</script>

<template>
  <div class="progress-wrapper">
    <div class="df-progress">
      <div class="df-progress__fill" :style="`width: ${(currentValue / totalValue) * 100}%`"></div>

      <div class="df-progress__error" :style="`width: ${(failedValues / totalValue) * 100}%`"></div>
    </div>

    <div>
      <p>{{ [currentValue, totalValue].join(' / ') }} {{ actionText }}</p>

      <p class="text--danger" v-if="failedValues > 0">{{ failedValues }} feilet</p>
    </div>
  </div>
</template>

<style scoped>
.progress-wrapper {
  display: grid;
  gap: var(--gap-sm);
}
.df-progress {
  width: 100%;
  height: 3px;
  display: flex;
  background-color: var(--color-darken);
  border-radius: var(--radius-sm);
  justify-content: space-between;
}

.df-progress__fill,
.df-progress__error {
  border-radius: var(--radius-sm);
  transition: width 0.2s;
}

.df-progress__fill {
  background-color: var(--color-primary);
}

.df-progress__error {
  background-color: var(--color-danger_text);
}

p {
  font-size: 0.8rem;
}
</style>
